import {Tabs} from 'foundation-sites';
import {throttle} from '../lib/throttle';

const audienceGrid = {

	$window: $(window),

	elem: {
		$body: $('body'),
		$tabs: $('#audience-grid-tabs')
	},

	tabs: false,

	init() {
		this.bindUIActions();

		if (this.elem.$tabs.length > 0) {
			this.setupTabs();
		}
	},

	bindUIActions() {



		if (this.tabs !== false) {
			_this.scrollSet(_this.elem.$tabs.parents('.audience-grid__tabs').find('.audience-grid__tabs-container'));
			_this.elem.$tabs.parents('.audience-grid__tabs')
				.find('.audience-grid__tabs-container')
				.on('scroll', throttle(this.onScroll.bind(this), 10));
		}

	},

	setupTabs() {

		this.tabs = new Tabs(this.elem.$tabs);

	},

	onScroll(e) {
		let $target = $(e.target);

		this.scrollSet($target);

	},

	scrollSet(el) {

		let width = el.outerWidth();
		let scrollLeft = el.scrollLeft();
		let scrollWidth = el[0].scrollWidth;

		el.parents('.audience-grid__tabs').toggleClass('audience-grid__tabs--has-shadow', ((Math.round(scrollWidth - width)) !== (Math.floor(scrollLeft) || Math.round(scrollLeft))));

	}

};

export {audienceGrid};
